import { styled } from "@styles";
import { Accordion, Card, Row } from "react-bootstrap";

export const Wrapper = styled(Accordion)``;

export const CheckoutOrderItemsCard = styled(Card)`
  margin-bottom: 1rem;
`;

export const CheckoutOrderItemsCardHeader = styled(Card.Header)`
  text-align: center;
`;

export const CheckoutOrderItemsCardHeaderTitle = styled(Accordion.Toggle)`
  font-weight: 700;
  text-transform: uppercase;
`;

export const CheckoutorderitemsCardCollapse = styled(Accordion.Collapse)``;

export const CheckoutOrderItemsCardBody = styled(Card.Body)`
  background-color: #eee;
`;

export const CheckoutOrderItemsSellerName = styled.p``;

export const CheckoutOrderItemsProduct = styled(Row)`
  background-color: white;
  margin: 2rem 0;
  align-items: center;
`;

export const CheckoutOrderItemsBrandName = styled.p`
  margin: 0;
`;

export const CheckoutOrderItemsProductName = styled.p`
  margin: 0;
  font-size: small;
  font-weight: 700;
`;

export const CheckoutOrderItemsQuantity = styled.label`
  font-weight: 700;
`;

export const CheckoutOrderItemsPrice = styled.label`
  font-weight: 700;
  float: right;
`;